module.exports = __webpack_public_path__ + "media/images/ceremony/top/plan/plan2-f8357d58fadaa1fac6f7c8fc1397543c.jpg";